import type { JSX } from 'react'
import React from 'react'
import Button from '../../Button'
import GrowingIcon from '../../GrowingIcon'
import { IconType } from '../../Icon'
import styles from './PlayButton.module.scss'
import { PlayButtonProps } from './types'

function getIcon (playing: boolean, pendingPlaybackRequest = false): JSX.Element {

  if (pendingPlaybackRequest) return <GrowingIcon icon={{ name: IconType.iconName.spinner }} />

  return (playing)
    ? <GrowingIcon
      icon={{
        name: IconType.iconName.pause
      }}
    />
    : <GrowingIcon
      icon={{
        name: IconType.iconName.play
      }}
    />

}

class PlayButton extends React.PureComponent<PlayButtonProps> {

  state = {
    playing: false
  }

  componentDidMount () {

    this.props.playerRef.addEventListener('play', this.setPlaying)
    this.props.playerRef.addEventListener('pause', this.setPaused)

  }

  componentWillUnmount () {

    if (this.props.playerRef) {

      this.props.playerRef.removeEventListener('play', this.setPlaying)
      this.props.playerRef.removeEventListener('pause', this.setPaused)

    }

  }

  setPlaying = () => this.setState({ playing: true })
  setPaused = () => this.setState({ playing: false })
  changeState = () => {

    if (typeof this.props.onPlay !== 'undefined') return this.props.onPlay()
    
    if (this.state.playing) this.props.playerRef.pause()
    else this.props.playerRef.play()

  }

  render () {

    return <Button
      onClick={this.changeState}
      color={this.state.playing ? IconType.colour.danger : IconType.colour.primary}
      className={styles['PlayButton']}
      dataBdd={`'player-controls'-play-button`}
    >
      {
        getIcon(typeof this.props.playing === 'undefined' ? this.state.playing : this.props.playing, this.props.pendingPlaybackRequest)
      }
    </Button>

  }

}

export default PlayButton
